import { Button, Divider, styled } from '@mui/material';
import { Column, Row } from 'further-ui/components/Layout';
import { PropsWithChildren, useState } from 'react';

const ViewButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0, 0, 0, theme.spacingSizes.sm),
  color: theme.palette.grey[600],
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    textDecoration: 'underline',
  },
}));

const PreviousResultsContainer: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [viewResponses, setViewResponses] = useState(false);

  const handleToggleViewResponses = () => {
    setViewResponses(!viewResponses);
  };

  const buttonText = viewResponses
    ? 'Hide old responses'
    : 'View old responses';

  return (
    <Column fullWidth spacing="sm">
      <Row fullWidth justify="flex-start">
        <ViewButton
          variant="text"
          color="primary"
          onClick={handleToggleViewResponses}
        >
          {buttonText}
        </ViewButton>
      </Row>
      {viewResponses ? (
        <Column fullWidth spacing="xxl">
          {children}
          <Divider />
        </Column>
      ) : null}
    </Column>
  );
};

export default PreviousResultsContainer;
